export default __webpack_public_path__ + "static/1309-dec12ee30530c3e1d1ea3c9a953492bb.gif";